<template>
  <div class="singled">
    <div class="singlemake">
      <div class="s_item">
        <span class="maketype">题型：{{issue.questiontype|type}}</span>
        <span>
          所属分类：
          <Cascader
            style="width:150px;display:inline-block"
            :placeholder="qbtitle"
            :data="questiontype"
            v-model="questionbasic"
          ></Cascader>
        </span>
        <span class="score">
          分数：
          <InputNumber :max="50" style="width:50px" :min="1" v-model="issue.questionscore"></InputNumber>
        </span>
        <span>
          知识点：
          <Select v-model="issue.questionpoint" style="width:100px;display:inline-block">
            <Option v-for="item in qplist" :key="item.qpid" :value="item.qpid">{{item.qptitle}}</Option>
          </Select>
        </span>
        <span>
          难易度：
          <Select v-model="issue.questionlevel" style="width:100px">
            <Option :value="1">易</Option>
            <Option :value="2">中</Option>
            <Option :value="3">难</Option>
          </Select>
        </span>
      </div>
      <div class="s_item">
        <div>题干：</div>
        <editor v-model="issue.question" style="flex-grow:1"></editor>
      </div>
      <div class="s_item" v-if="issue.questiontype==1">
        <div>选项：</div>
        <div>
          <Radio-group style="width:100%" v-model="questionanswer">
            <div v-for="(item,index) in choiceitem " :key="'choice'+index" class="questitem">
              <Radio :label="index">
                <span style="margin-right:10px;">{{(index+1) | tochange}}</span>
              </Radio>
              <editor v-model="item.content" style="width:660px"></editor>
              <span class="questitem_operate">
                <img
                  v-if="index==(choiceitem.length-1)"
                  src="../assets/icons/add.png"
                  @click="additem"
                  alt
                >
                <img src="../assets/icons/del.png" @click="del(index)" alt>
              </span>
            </div>
          </Radio-group>
        </div>
      </div>
      <div class="s_item" v-if="issue.questiontype==2">
        <div>选项：</div>
        <div style="width:800px">
          <Checkbox-group style="width:100%" v-model="questionanswer">
            <div v-for="(item,index) in choiceitem " :key="'choice'+index" class="questitem">
              <Checkbox :label="index" style="width:60px;">
                <span>{{(index+1) | tochange}}</span>
              </Checkbox>
              <editor v-model="item.content" style="width:660px"></editor>
              <span class="questitem_operate">
                <img
                  v-if="index==(choiceitem.length-1)"
                  src="../assets/icons/add.png"
                  @click="additem"
                  alt
                >
                <img src="../assets/icons/del.png" @click="del(index)" alt>
              </span>
            </div>
          </Checkbox-group>
        </div>
      </div>
      <div class="s_item" v-if="issue.questiontype==3">
        <div>选项：</div>
        <div style="width:800px">
          <Radio-group style="width:100%" v-model="questionanswer">
            <div v-for="(item,index) in choiceitem " :key="'choice'+index" class="questitem">
              <div class="content">
                <span style="margin-right:10px;">{{(index+1) | tochange}}</span>
                <i-input
                  type="text"
                  v-model="item.content"
                  style="width:5rem"
                  :rows="3"
                  placeholder="请输入..."
                ></i-input>
              </div>
              <div>
                <Radio :label="index">正确选项</Radio>
              </div>
            </div>
          </Radio-group>
        </div>
      </div>
      <div class="s_item" v-if="issue.questiontype==4">
        <div>答案：</div>
        <div style="width:800px">
          <i-input
            type="textarea"
            style="width:100%"
            v-model="issue.questionanswer"
            :rows="3"
            placeholder="请输入答案，多个答案请用','号风隔断"
          ></i-input>
        </div>
      </div>
      <div class="s_item" v-if="issue.questiontype==5">
        <div>答案：</div>
        <div style="width:800px">
          <i-input
            type="textarea"
            style="width:100%"
            v-model="issue.questionanswer"
            :rows="3"
            placeholder="请输入答案"
          ></i-input>
        </div>
      </div>
      <div class="s_item" style="justify-content:space-around">
        <div class="button" @click="exit">取消</div>
        <div class="button" @click="complate">完成编辑</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Question_add, Question_update } from "../assets/js/api.js";
// htmlDecodeByRegExp
import unit from "../assets/js/unit.js";
import editor from "./editor";
export default {
  // questionitem	string	true	普通参数		0客观题1主观题---------------------------------------
  // questiontype	string	true	普通参数		试题题型---------------------
  // questionbasic	string	true	普通参数		试题分类-------------------------
  // question	string	true	普通参数		试题+--------------------
  // questionselect	string	true	普通参数		选项
  // questionanswer	string	true	普通参数		答案-------------------------------
  // questiondescribe	string	true	普通参数		知识点-----------------
  // questionscore	string	true	普通参数		分值-------------------------------
  // questionnecessary	string	true	普通参数		0选答1必答-------------------------
  // questionlevel	string	true	普通参数		1简单2中等3困难-------------------------
  // {"A": {"txt": "选项A","image": "/image/a.jpg"},
  // "B": {"txt": "选项B","image": "/image/b.jpg"},
  // "C": {"txt": "选项C","image": "/image/c.jpg"},
  // "D": {"txt": "选项D","image": "/image/d.jpg"}}
  name: "siglechoicemake",
  data() {
    return {
      choiceitem: [
        {
          content: ""
        },
        {
          content: ""
        },
        {
          content: ""
        },
        {
          content: ""
        }
      ],
      choiceitemIndex: null,
      questionbasic: [],
      questionanswer: undefined,
      issue: {
        question: "",
        questionscore: 5,
        questionbasic: [],
        questiontype: 1,
        questionitem: 0,
        questionnecessary: 1,
        questionlevel: null,
        questionpoint: null,
        questionselect: null
      }
    };
  },
  components: {
    editor
  },
  filters: {
    tochange(value) {
      return ["A", "B", "C", "D", "E", "F"][value - 1];
    },
    type(value) {
      return ["说明", "单选题", "多选题", "判断题", "填空题", "问答题"][value];
    }
  },
  mounted() {
    this.issue.questiontype = this.message.questiontype;
    if (this.message.questiontype == 4 || this.message.questiontype == 5) {
      this.issue.questionitem = 1;
    }
    if (this.message.questiontype == 3) {
      this.choiceitem = [
        {
          content: "对"
        },
        {
          content: "错"
        }
      ];
    }
    if (this.message.questionid) {
      this.init();
    } else {
      this.issue.questionpoint = 0;
    }
  },
  computed: {
    questiontype() {
      return this.$store.state.questiontype;
    },
    qbtitle() {
      return this.$store.state.classmap.get(this.message.questionbasic - 0);
    },
    qplist() {
      return this.$store.state.qplist;
    }
  },
  props: ["message"],
  methods: {
    init() {
      this.issue = this.message;
      // 关于选项的转换
      this.choiceitem = [];
      for (var item in this.message.questionselect) {
        this.choiceitem.push({
          content: this.message.questionselect[item].txt
        });
      }
      // 关于一些值得初始化
      this.issue.questionscore = this.issue.questionscore - 0;
      this.issue.questionlevel = this.issue.questionlevel - 0;
      this.issue.questionpoint = this.issue.questionpoint - 0;
      // 关于答案解析
      // 单选题和判断题
      if (
        (this.issue.questiontype == 1 || this.issue.questiontype == 3) &&
        this.issue.questionanswer
      ) {
        this.questionanswer = this.tochanged(this.issue.questionanswer) - 1;
      }
      // 多选题
      if (this.issue.questiontype == 2 && this.issue.questionanswer) {
        this.questionanswer = this.message.questionanswer
          .toString()
          .split(",")
          .filter(item => item)
          .map(item => {
            return this.tochanged(item) - 1;
          });
      }
      // 填空题和问答题
      if((this.issue.questiontype == 4 || this.issue.questiontype == 5)&&this.issue.questionanswer){
        this.issue.questionanswer = this.issue.questionanswer
        ? this.issue.questionanswer.replace(/\<br \/\>/g, "")
        : this.issue.questionanswer;
      }
    },
    additem() {
      if (this.choiceitem.length > 5) {
        this.errorPlus("选项太多，请慎重增加");
        return;
      }
      this.choiceitem.push({
        content: ""
      });
    },
    del(index) {
      if (this.choiceitem.length == 1) {
        this.errorPlus("选项不能少一个");
        return;
      }
      this.choiceitem.splice(index, index + 1);
    },
    exit() {
      this.init();
      this.$emit("exit");
    },
    complate() {
      if (!this.issue.question) {
        this.errorPlus("题目标题不可为空！");
        return;
      }
      if (
        this.choiceitem.some(item => {
          return item.content + item.image == "";
        })
      ) {
        this.errorPlus("不可有空选项！");
        return;
      }
      if (this.issue.questionpoint !== 0 && !this.issue.questionpoint) {
        this.errorPlus("知识点不可为空！");
        return;
      }
      this.issue.questionselect = {};
      this.choiceitem.forEach((item, index) => {
        this.issue.questionselect[this.tochanged(index + 1)] = {
          txt: item.content,
          image: ""
        };
      });
      var data = JSON.parse(JSON.stringify(this.issue));
      if (this.questionbasic.length) {
        data.questionbasic = this.questionbasic[this.questionbasic.length - 1];
      }
      data.questionnecessary = 1;
      //答案载入
      if (this.issue.questiontype == 1 || this.issue.questiontype == 3) {
        data.questionanswer = this.tochanged(this.questionanswer + 1);
      }
      if (this.issue.questiontype == 2) {
        data.questionanswer = this.questionanswer
          .map(item => {
            return this.tochanged(item + 1);
          })
          .filter(item => {
            return item;
          })
          .join(",");
      }

      // 多余属性的删除
      delete data.qbtitle;
      delete data.qttitle;
      delete data.qptitle;
      delete data.isedit;
      delete data.questionusername;
      delete data.questioncreatetime;
      delete data.hasedit;
      if (data.questionid) {
        Question_update(data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "编辑成功！" });
            this.$emit("complate", data);
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      } else {
        Question_add(data).then(res => {
          if (res.data.code == 200) {
            this.$Notice.success({ title: "成功提示", desc: "添加成功！" });
            var d = data;
            d.questionid = res.data.data - 0;
            this.issue.questionid = res.data.data - 0;
            this.$emit("complate", d);
            return;
          }
          this.$Notice.warning({ title: "信息提示", desc: res.data.message });
        });
      }
    },
    tochanged(value) {
      switch (value) {
        case 1:
          return "A";
        case 2:
          return "B";
        case 3:
          return "C";
        case 4:
          return "D";
        case 5:
          return "E";
        case 6:
          return "F";
        case 7:
          return "G";
        case 8:
          return "H";
        case 9:
          return "I";
        case "A":
          return 1;
        case "B":
          return 2;
        case "C":
          return 3;
        case "D":
          return 4;
        case "E":
          return 5;
        case "F":
          return 6;
        case "G":
          return 7;
        case "H":
          return 8;
        case "I":
          return 9;
      }
    }
  }
};
</script>
<style lang="css" scoped>
.title {
  word-break: break-all;
  word-wrap: break-all;
  white-space: normal;
}
/* .singled {
  background: #f9fafc;
} */
.singlechoice {
  text-align: left;
  color: #575e6b;
  line-height: 0.25rem;
  font-size: 0.14rem;
}
.choice {
  margin: 0.1rem 0 0;
}
.choice .item {
  color: #575e6b;
  font-size: 0.14rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}

.choice .item.act {
  color: #474dff;
}
.questitem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.questitem_operate {
  width: 0.8rem;
  display: inline-block;
}
.questitem img {
  cursor: pointer;
}
.type {
  display: inline-block;
  width: 0.6rem;
  height: 0.2rem;
  line-height: 0.18rem;
  border: 1px solid #45d359;
  background: #ddffe2;
  color: #45d359;
  font-size: 0.14rem;
  text-align: center;
  border-radius: 2px;
  margin: 0 0.2rem;
}
.singlemake {
  /* margin-top: 40px; */
  /* margin-bottom: 10px; */
  /* border: 1px solid red; */
  margin-left:15px;
}
.s_item {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  text-align: right;
  font-size: 14px;
  align-items: center;
  line-height: 30px;
}
.maketype {
  margin-top: -2px;
}
.button {
  width: 0.9rem;
  height: 0.3rem;
  color: #fff;
  background: #4b51ff;
  line-height: 0.3rem;
  border-radius: 0.02rem;
  font-size: 0.14rem;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0.15rem;
}
.operate {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.4rem;
}
.operate > div {
  margin: 0 0.15rem;
}
</style>


// WEBPACK FOOTER //
// src/components/make.vue